module.exports = __webpack_public_path__ + "static/media/adesivo_l4.d4676232.png";